/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateVideoTutorial from 'components/VideoTutorial/create.videoTutorial';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const VideoTutorialCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลวีดีโอสอนการใช้งาน' : 'สร้างข้อมูลวีดีโอสอนการใช้งาน' }</title>
         </Helmet>
         <HasAccess
            roles={['Masteradmin']}
            permissions={['category-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลวีดีโอสอนการใช้งาน' : 'สร้างข้อมูลวีดีโอสอนการใช้งาน' }`}>
               <CreateVideoTutorial id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default VideoTutorialCreatePage;
